import { t } from "i18next";
import { Table, Typography, Text } from "antd";
import Helper from "../../../core/Helper";
import ReactJson from "react-json-view";

export default function LogsPreview({ logs }) {

    const renderDescription = (row) => {
        if(row.description) {
            return row.description
        }

        if(row.type === 1) {
            return t('CHANGE_APPOINTMENT')
        }
        else if(row.type === 2) {
            return t('DELETE_PAYMENT')
        }
        else if(row.type === 3) {
            return t('CHANGE_APPOINTMENT_INSTITUTION')
        }
        else if(row.type === 4) {
            return t('CREATE_APPOINTMENT')
        }
        else if(row.type === 5) {
            return t('CHANGE_APPOINTMENT_STATE')
        }
        else if(row.type === 6) {
            return t('CREATE_PAYMENT')
        }
        else if(row.type === 7) {
            return t('CHANGE_PAYMENT')
        }
        else if(row.type === 8) {
            return t('DELETE_APPOINTMENT')
        }
        else if(row.type === 9) {
            return t('CHANGE_APPOINTMENT_ENTITLEMENT')
        }
        else if(row.type === 10) {
            return t('APPOINTMENT_STATE_DESCRIPTION')
        }
        else if(row.type === 11) {
            return t('RESTORE_APPOINTMENT')
        }
        else if(row.type === 12) {
            return t('SEND_ENTITLEMENT_CONFIRMATION')
        }
        else if(row.type === 13) {
            return t('CANCEL_ENTITLEMENT_CONFIRMATION')
        }
        else if(row.type === 14) {
            return t('CONFIRM_ENTITLEMENT')
        }
        else if(row.type === 15) {
            return t('DELETE_OPERATIONS')
        }
        else if(row.type === 16) {
            return t('EDIT_OPERATIONS')
        }
        else if(row.type === 17) {
            return t('ADD_OPERATIONS')
        }

        return '-'
    }

    const formatData = (data) => {
        Object.keys(data).forEach(key => {
            const dateKeys = ['paymentDate', 'next_PaymentDate', 'previous_PaymentDate', 'startDate', 'endDate', 'previous_StartDate', 'next_StartDate', 'previous_EndDate', 'next_EndDate']
            if(dateKeys.includes(key)) {
                data[key] = new Date(data[key]).toLocaleString()
            }
        })

        return data
    }

    const renderData = (row) => {
        try {
            const data = JSON.parse(row?.data);
            if(typeof data === 'string') {
                throw new Error('Not a JSON');
            }
            return (
                <div style={{height: 70, overflowY: 'auto'}}>
                    <ReactJson
                        src={formatData(data)}
                        displayDataTypes={false}
                        displayObjectSize={false}
                    />
                </div>
            )
        }
        catch (exp) {
            return row?.data.replaceAll('"', '').split('@').map((item, index) => {
                return (
                    <>
                        {item}
                        <br/>
                    </>
                )
            })
        }
    }

    return (
        <Table
            size={'small'}
            dataSource={logs}
            rowKey={'id'}
            columns={[
                { dataIndex: 'createdDate', key: 'createdDate', title: t('Created Date'), render: (val, row) => new Date(val).toLocaleString(), width: 175 },
                { dataIndex: 'user', key: 'user', title: t('User'), render: (val, row) => row?.user?.name, width: 175 },
                { dataIndex: 'description', key: 'description', title: t('Description'), render: (text, row) => renderDescription(row), width: 600 },
                {
                    dataIndex: 'data', key: 'data', title: t('Data'), render: (val, row) => renderData(row)
                }
            ]}
        />
    )
}